import { GameItem, TileLoot } from 'dt-common/generated/zod';
import Colors from '~/constants/Colors';
import onLootImgMouseover from './onLootImgMouseover';

const LootSpawnRendering = {
  render: function (data: { tileId: string; tile: { loot: TileLoot; }; }, gameBoard) {
    const tileSprite = gameBoard.getAllPieceSprites()[data.tileId];
    if (!tileSprite) {
      return;
    }

    // render the loot image
    if (!tileSprite.lootImg) tileSprite.lootImg = tileSprite.txtPool.get();
    tileSprite.lootImg.scale.x = 0.5;
    tileSprite.lootImg.scale.y = 0.5;
    tileSprite.addChild(tileSprite.lootImg);
    tileSprite.tileImg.visible = false;

    // determine text symbol and tint
    const { loot } = data.tile;
    if (!Array.isArray(loot?.items) && typeof loot?.items === 'object') {
      loot.items = Object.values(loot.items);
    }
    if (
      (loot.gold && loot.pd) ||
      (loot.gold && loot.items?.[0]) ||
      (loot.pd && loot.items?.[0]) ||
      loot?.items?.length > 1
    ) {
      // pile of loot
      tileSprite.lootImg.text = '&';
      tileSprite.lootImg.tint = loot.items?.[0]
        ? loot.items[0].tint
        : loot.pd
          ? Colors.PIXIE_DUST
          : Colors.GOLD;
    } else if (loot.gold) {
      tileSprite.lootImg.text = '$';
      tileSprite.lootImg.tint = Colors.GOLD;
    } else if (loot.pd) {
      tileSprite.lootImg.text = '*';
      tileSprite.lootImg.tint = Colors.PIXIE_DUST;
    } else if (loot.items?.[0]) {
      const item = loot.items[0];
      tileSprite.lootImg.text = getEquipmentSymbol(item);
      tileSprite.lootImg.tint = item.tint;
    }

    // add mouseover functionality
    tileSprite.lootImg.interactive = true;
    tileSprite.lootImg.interactiveChildren = true;
    tileSprite.lootImg.mouseover = tileSprite.lootImg.touch =
      onLootImgMouseover;
  },
};
export default LootSpawnRendering;

const getEquipmentSymbol = (item: GameItem) => {
  switch (item.slot) {
    case 'boots':
      return '7';
    case 'helmet':
      return '^';
    case 'off_hand':
      switch (item.type) {
        case 'book':
          return '"';
        case 'bow':
          return '}';
        case 'shield':
          return '0';
        case 'trinket':
          return '%';
      }
      break;
    case 'torsoe':
      return ']';
    case 'weapon':
      switch (item.type) {
        case 'dagger':
          return '`';
        case 'hammer':
          return '?';
        case 'staff':
          return '/';
        case 'sword':
          return '(';
      }
      break;
    case 'ring':
      return '~';
  }

  return ';';
};
